import React from 'react';

export default function GenerateButton({ label, cost, isGenerating, progress, disabled, onClick, t }) {
  const className = `mv-generate ${isGenerating ? 'generating' : disabled ? 'is-disabled' : 'is-ready'}`;
  const style = isGenerating ? { '--progress': progress } : undefined;
  const text = isGenerating
    ? t('videoGeneration.mv.actions.generatingWithCredits', { progress: Math.round(progress), count: cost })
    : t('videoGeneration.mv.actions.generateWithCredits', { label, count: cost });

  return (
    <button className={className} disabled={disabled || isGenerating} onClick={onClick} style={style}>
      <span className="mv-generate__label">{text}</span>
    </button>
  );
}
